import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="section">
        <div className="container">
          <h1 className="section-title">About the Maker</h1>
          
          <div className="about-content">
            <div className="about-image">
              <div className="placeholder-image">
                <span>👨‍💻</span>
                <p>Photo Coming Soon</p>
              </div>
            </div>
            
            <div className="about-text card">
              <h2>The Story Behind Strebla Innovations</h2>
              <p>
                Welcome to Strebla Innovations! I'm the builder behind this operation,
                and I'm here to tell you a little bit about how this all came to be.
              </p>
              <p>
                Picture this: a garage, a Raspberry Pi, and way too much coffee. That's
                where it all started. I've always believed that great things don't need
                fancy offices or million-dollar budgets—they just need passion, creativity,
                and maybe a few late-night coding sessions.
              </p>
              <p>
                I'm a software developer and designer who loves building things that matter.
                Whether it's a sleek web app or a solution to a problem nobody knew existed,
                I'm always tinkering, always learning, and always pushing the boundaries
                of what's possible.
              </p>
              <p>
                The name "Strebla" might sound mysterious, but it's really just a reminder
                that innovation doesn't have to be complicated. Sometimes the best solutions
                come from the simplest places—like a garage with a Raspberry Pi.
              </p>
              <div className="about-highlight">
                <p>
                  <strong>Built with:</strong> Passion, coffee, and a Raspberry Pi in a garage.
                  <br />
                  <strong>Powered by:</strong> The belief that great software should be
                  accessible to everyone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

